<style lang="less">
@import "../../../styles/public/public.less";
@import "../less/showmodel.less";
</style>
<template>
<div class="showmodel">
    <div class="showmodel_1 display_wrap_as set_yj">
        <titles titles="详细信息"></titles>
        <div v-for="item in editInfo" class="showmodel_1hz display_row_ac media_w_showmodel1hz">
            <div class="showmodel_1hz_1 display_row_jc_ac dispaly_flex00">
                <span>{{item.name}}:</span>
            </div>
            <div class="showmodel_1hz_2 display_row_ac dispaly_flex11 ">
                <span>{{item.value}}</span>
            </div>
        </div>
        <div style="height: auto;width:100%;margin-top:10px;" class="showmodel_1hz display_row_ac media_w_showmodel1hz">
            <div class="showmodel_1hz_1 display_row_jc_ac dispaly_flex00" style="margin-bottom: 10px;">
                <span>营业执照照片:</span>
            </div>
            <div style="margin-bottom: 10px;cursor:pointer;" class="showmodel_1hz_2 display_row_ac dispaly_flex11 " v-viewer>
                <img style="width:120px;height:100px;" :src="picurl"/>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import titles from "../../pages/title.vue";
import bus from "../../../app/event";
export default {
    components: {
        titles
    },
    // props:{
    //   showData:Object,
    // },
    data() {
        return {
            unit: {},
            disabled: false,
            picurl:'./static/images/example.png',
            editInfo: [{
                    name: '单位名称',
                    value: '',
                    type: 'mc',
                },
                {
                    name: '社会信用代码',
                    value: '',
                    type: 'creditcode',
                },
                {
                    name: '单位地址',
                    value: '',
                    type: 'dwdz',
                },
                {
                    name: '邮编',
                    value: '',
                    type: 'yb',
                },
                {
                    name: '单位负责人',
                    value: '',
                    type: 'fzr',
                },
                {
                    name: '联系电话',
                    value: '',
                    type: 'dh',
                },
                {
                    name: '单位性质',
                    value: '',
                    type: 'dwxz',
                }
            ]
        };
    },
    methods: {},
    mounted() {
        let that=this;
        bus.$on('showunit', (showData) => {
            this.editInfo.map((item, index) => {
                item.value = showData[item.type];
            })
            showData.imgurl!=''?that.picurl=appurl.imgurl+showData.imgurl:that.picurl='./static/images/example.png';
            
        })
    },
    beforeDestroy() {
        bus.$off('showunit');
    },
    directives: {}
};
</script>



// WEBPACK FOOTER //
// showmodel.vue?3a40f904